export default "__VITE_ASSET__Ch1921Es__"